import BrandSelect from "./BrandSelect";
import { FormProvider, Controller, useForm } from "react-hook-form";
import { inputClass } from "../utils/classes";
import YearSelect from "./YearSelect";
import { useRouter } from "next/router";
import { classNames, generateSlug } from "../utils/formatters";
import { useEffect } from "react";

/*
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/

type TFormData = {
  brand: {
    name: string;
  };
  model: string;
  year: number;
};

export default function CarValueForm({
  formData,
  formClassName,
  submitButtonClassName,
}: {
  formData?: TFormData;
  formClassName?: string;
  submitButtonClassName?: string;
}) {
  const router = useRouter();
  const methods = useForm();
  const { register, handleSubmit, formState, control, reset } = methods;
  const { errors } = formState;

  useEffect(() => {
    if (formData) {
      reset({
        ...formData,
      });
    }
  }, [formData]);

  const onSubmit = async (formData) => {
    const { brand, model, year } = formData;
    router.push(
      `/valor-de-mi-auto/${generateSlug(brand.name)}_${generateSlug(
        model
      )}_${year}`
    );
  };

  let loading = false;

  return (
    <FormProvider {...methods}>
      <form
        className={classNames(formClassName)}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Controller
          name="brand"
          rules={{ required: true }}
          control={control}
          render={({ field }) => <BrandSelect {...field} disabled={loading} />}
        />
        <div>
          <label
            htmlFor="model"
            className="block text-sm font-medium text-gray-700"
          >
            Modelo
          </label>
          <div className="mt-1">
            <input
              {...register("model", {
                required: true,
                maxLength: 30,
              })}
              type="text"
              autoComplete="off"
              className={inputClass(errors.model, null, loading)}
              disabled={loading}
            />
          </div>
        </div>
        <Controller
          name="year"
          rules={{
            required: true,
            pattern: {
              value: /^(0|[1-9]\d*)(\.\d+)?$/,
              message: "Only numbers allowed",
            },
          }}
          control={control}
          render={({ field }) => <YearSelect {...field} disabled={loading} />}
        />

        <div>
          <button
            type="submit"
            className={classNames(
              "flex w-full justify-center rounded-md bg-orange-500 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-orange-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500",
              submitButtonClassName
            )}
          >
            Calcular
          </button>
        </div>
      </form>
    </FormProvider>
  );
}
